import React, {useState} from 'react'
import {observer} from 'mobx-react'
import ListPageLayout from '../common/layout/ListPageLayout'
import EditProduct from '../product/components/EditProduct'
import {useStores} from '../../store'
import {ErrorComponent, FullLoader} from '../common'
import AbdaTable from './components/AbdaTable'
import {FileExtension} from '../../utils/enums'
import {usePagination} from '../../utils/hooks/usePagination'
import {TablePaginationConfig} from 'antd'
import {i18n} from '../../i18n'

const AbdaPage = observer(() => {
    const {abdaStore} = useStores()
    const [sortField, setSortField] = useState<string>()
    const [sortOrder, setSortOrder] = useState<string>()
    const [loading, paginationConfig] = usePagination(abdaStore, undefined, sortField, sortOrder)

    if (abdaStore.dataList === null) {
        return <FullLoader />
    }

    if (abdaStore.dataList === undefined) {
        return <ErrorComponent status={404} />
    }

    const handleTableChange = (pagination: TablePaginationConfig, filters: any, sorter: any) => {
        setSortField(sorter.field)
        setSortOrder(sorter.order)
    }

    return (
        <ListPageLayout
            title={i18n.t('abda.pageTitle')}
            showUploadButton={true}
            hideCreateButton={true}
            createModal={EditProduct}
            draggerProps={{store: abdaStore, acceptedExtensions: [FileExtension.ZIP]}}
            customButton={{action: async () => abdaStore.export(), labelKey: 'abda.export.button'}}
        >
            <AbdaTable data={abdaStore.dataList} loading={loading} pagination={paginationConfig} onTableChange={handleTableChange} />
        </ListPageLayout>
    )
})

export default AbdaPage
